import apiinfo from "../../../../utils/base-uri.json";
import { useForm } from "react-hook-form";
import OutlinedInput from "@mui/material/OutlinedInput";
import { FormControl, InputLabel, Select, MenuItem, Tooltip, ListItemText, Button, TextField } from '@mui/material'
import React, { useState, useEffect } from 'react'
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import axios from "../../../../utils/fvAxios";
import BaseURL from "../../../../utils/base-uri.json";
import { getGlobalClientId, getToken, getOrgType } from "../../../../utils/Token";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

export default function ReportInvitationSent({ close, name }) {
  const [client, setClient] = React.useState([]);
  const [error, setError] = useState(null);
  const [token, setToken] = useState(getToken());

  useEffect(() => {
    axios
      .get("Prequalification/GetAllClients?getAll=false&isIncludeMultiClient=false&ClientIds=" + getGlobalClientId())
      .then((res) => {
        if (res.data.responseCode === 100) {
          setClient(res.data.data);
          if (getOrgType() === 'Client') {
            setSelectValue1(res?.data?.data[0]?.value);
          } else {
            // Handle other org types if needed
          }
        } else {
          setError(res.data.responseMessage);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const { register } = useForm();
  const [selectValue1, setSelectValue1] = useState("");
  const [fromDateValue, setFromDateValue] = useState(null);
  const [toDateValue, setToDateValue] = useState(null);
  const [showAlert, setShowAlert] = useState(false);

  const changeClients = (e) => {
    setSelectValue1(e);
  };

  const ITEM_HEIGHT = 50;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 5 + ITEM_PADDING_TOP,
        width: 200,
      },
    },
  };

  const handleFromDateChange = (date) => {
    setFromDateValue(date);
    if (date && toDateValue && date > toDateValue) {
      setShowAlert(true);
    } else {
      setShowAlert(false);
    }
  };

  const handleToDateChange = (date) => {
    setToDateValue(date);
    if (fromDateValue && date && fromDateValue > date) {
      setShowAlert(true);
    } else {
      setShowAlert(false);
    }
  };

  const handleDateKeyDown = (e) => {
    e.preventDefault(); // Prevent manual date input
  };

  return (
    <>
      <DialogTitle id="alert-dialog-title">{name}</DialogTitle>
      <DialogContent>
        {showAlert && (
          <div className="alert mx-5" style={{ color: "red" }}>
            From date should be less than To date
          </div>
        )}
        <form
          action={BaseURL?.baseReportUrl + "InvitationsSent.aspx"}
          method="post"
          target="_blank"
        >
          <div style={{ marginLeft: "25px" }}>
            <FormControl sx={{ m: 1, width: 320 }}>
              <span
                style={{
                  color: "#3E4A62",
                  fontSize: "14px",
                  fontWeight: "500",
                  marginTop: "5px",
                  marginBottom: "5px",
                }}
              >
                Client
              </span>
              <Select
                labelId="demo-multiple-name-label"
                id="demo-multiple-name"
                {...register("client")}
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                  fontFamily: "Arial, FontAwesome",
                }}
                size="small"
                name="ClientId"
                displayEmpty={getOrgType() !== "Client"}
                onChange={(e) => changeClients(e?.target?.value)}
                input={<OutlinedInput label="Select Client" value={selectValue1} />}
                MenuProps={MenuProps}
              >
                <MenuItem value="" hidden={getOrgType() === "Client"}>
                  Any
                </MenuItem>
                {client?.map((item, index) => (
                  <MenuItem key={index} value={item?.value} title={item?.text} sx={{ overflowX: "hidden", textOverflow: "ellipsis" }}>
                    {item.text}
                  </MenuItem>
                ))}
              </Select>
              <span style={{ color: "#3E4A62", fontSize: "14px", fontWeight: "500", marginTop: "5px", marginBottom: "5px" }}>From</span>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  views={["year", "month", "day"]}
                  value={fromDateValue}
                  onChange={handleFromDateChange}
                  name="fromDate"
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      sx={{
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                        width: "320px",
                      }}
                      size="small"
                      name="fromDate"
                      onKeyDown={handleDateKeyDown}
                    />
                  )}
                />
              </LocalizationProvider>
              <span style={{ color: "#3E4A62", fontSize: "14px", fontWeight: "500", marginTop: "5px", marginBottom: "5px" }}>To</span>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  views={["year", "month", "day"]}
                  value={toDateValue}
                  name="toDate"
                  onChange={handleToDateChange}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      sx={{
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                        width: "320px",
                      }}
                      name="toDate"
                      size="small"
                      onKeyDown={handleDateKeyDown}
                    />
                  )}
                />
              </LocalizationProvider>
            </FormControl>
          </div>
          <DialogActions>
            <div className="login-help__buttonContainer">
              <Button
                variant="contained"
                className="login-help-button-cancel"
                onClick={close}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                type="submit"
                className="login-button-request"
                onClick={close}
                disabled={showAlert || fromDateValue === null || toDateValue === null}
              >
                Create Report
              </Button>
            </div>
          </DialogActions>
          <input type="hidden" name="token" value={token} />
        </form>
        <br />
      </DialogContent>
    </>
  );
}
